module.exports = __webpack_public_path__ + "static/media/cpg_drive_toothbrush_sales.423ee351.png";